import { configureStore } from "@reduxjs/toolkit";
import eventOrganiserSlice from "../features/EventOrganiser/redux/eventOrganiserSlice";
import authSlice from "../auth/authSlice";
import branchReducer from "../features/SchoolModule/branch/redux/branchSlice.js";
import classReducer from "../features/SchoolModule/classes/redux/classSlice.js";
import sectionReducer from "../features/SchoolModule/sections/redux/sectionSlice.js";
import teacherReducer from "../features/SchoolModule/teachers/redux/teacherSlice.js";
import subjectReducer from "../features/SchoolModule/subjects/redux/subjectSlice.js";
// import timetableReducer from '../features/SchoolModule/timetable/redux/timetableSlice.js'
import periodReducer from "../features/SchoolModule/periods/redux/periodSlice.js";
// import classTeacherReducer from '../features/SchoolModule/classTeacher/redux/classTeacherSlice.js'
// import subjectPermissionReducer from './slices/subjectPermissionSlice.js';
import CreateQstnPaperReducer from "../features/QuestionPaper/createpaper/redux/slice.js";
import academicCalendarReducer from "../features/AcademicCalendar/redux/academicCalendarSlice.js";
import PaperEditorReducer from "../features/QuestionPaper/createpaper/redux/editorSlice.js";
import userSlice from "../pages/user/redux/userSlice.js";
import substituteTeacherReducer from "../features/SchoolModule/substituteTeacher/redux/substituteTeacherSlice.js";
import chapterSlice from "../features/QuestionBank/redux/chapterSlice.js";
import questionBankReducer from "../features/QuestionBank/redux/questionBankSlice.jsx";
import timeTableReducer from "../features/SchoolModule/generateTimetable/redux/timetableSlice.js";
import masterDataReducer from "../pages/masterData/redux/masterDataSlice.js";
import prefillReducer from "../pages/prefills/redux/prefillSlice.js";
import syllabusReducer from "../features/TeachersPlanner/redux/syllabusSlice.js";
import myTimetableReducer from "../features/TeachersPlanner/TimeTable/redux/myTimetableSlice.js";
import projectReducer from "../features/TeachersPlanner/Projects/redux/projectSlice.js";
import projectsReducer from "../features/AcademicCalendar/redux/projectsSlice.js";
import eventRequestReducer from "../features/AcademicCalendar/redux/eventRequestSlice.js";
import topicReducer from "../features/TeachersPlanner/WeeklyLessons/redux/topicSlice.js";
import homeworksReducer from "../features/TeachersPlanner/WeeklyLessons/HomeWorks/redux/myHomeworksSlice.js";
import paymentReducer from "../features/pricing/redux/slice.js";
import ticketsReducer from "../features/ticketing-app/redux/ticketingSlice.js";
import eligibilityReducer from "../features/EligibilityData/redux/slice.js";
import quizReducer from "../features/Quiz/redux/quizSlice.js";
import studentQuizReducer from "../features/StudentQuiz/redux/studentQuiz.js";
import studentReducer from "../features/student/redux/studentSlice.js";
import registerReducer from "../features/QuestionPaper/createpaper/components/registration/redux/registerSlice.js";
import allPaperReducer from "../features/QuestionPaper/AllPapers/redux/slice.js";

// import joyrideReducer from "../features/SchoolModule/redux/joyrideSlice.js"
import globalJoyrideReducer from "../redux/globalJoyrideSlice.js";
const store = configureStore({
  reducer: {
    eventOrganiser: eventOrganiserSlice,
    authSlice: authSlice,
    branches: branchReducer,
    classes: classReducer,
    sections: sectionReducer,
    teachers: teacherReducer,
    subjects: subjectReducer,
    // timetable: timetableReducer,
    periods: periodReducer,
    // classTeachers: classTeacherReducer,
    createQstnPaper: CreateQstnPaperReducer,
    academicCalendar: academicCalendarReducer,
    createPaperEditor: PaperEditorReducer,
    user: userSlice,
    chapter: chapterSlice,
    questionBank: questionBankReducer,
    timetable: timeTableReducer,
    substitutes: substituteTeacherReducer,
    masterData: masterDataReducer,
    prefill: prefillReducer,
    syllabus: syllabusReducer,
    myTimetable: myTimetableReducer,
    project: projectReducer,
    projects: projectsReducer,
    eventRequest: eventRequestReducer,
    topic: topicReducer,
    homeworks: homeworksReducer,
    paymentGateway: paymentReducer,
    tickets: ticketsReducer,
    eligibility: eligibilityReducer,
    quiz: quizReducer,
    studentQuiz: studentQuizReducer,
    student: studentReducer,
    register: registerReducer,
    allPapers: allPaperReducer,
    globalJoyride: globalJoyrideReducer,
  },
  // Below workaround to avoid errors
middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["globalJoyride.steps"],
      ignoredActionPaths: ["payload.steps"],
    },
  }),
});

export default store;
